import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from 'react-bootstrap/Button';
import { useParams, useNavigate } from 'react-router-dom';
import toast from '../../service/toaster';
import './addPrediction.css';
import matchService from '../../service/matchService'
import predictionService from '../../service/predictionService'
import { redirectToLogin } from '../../service/authRedirect';


export default function MatchPrediction() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [match, setMatch] = useState(null);
  const [selections, setSelections] = useState({});
  const [submitted, setSubmitted] = useState(true); // New state for tracking submission

  useEffect(() => {
    getItems();
  },[id]);

  useEffect(()=>{
    if (match) {
      // Check if userPrediction is present
      if (match.userPrediction&&false) {
        setSelections(match.userPrediction);
        setSubmitted(true); // Set to true to disable submit if predictions are pre-filled
      } else {
        const initialSelections = {
          team1: { winner: true },
          team2: { winner: true }
        };

        match.sessions.forEach(session => {
          initialSelections.team1[session] = null;
          initialSelections.team2[session] = null;
        });

        setSelections(initialSelections);
      }
    }
  },[match])
  const getItems = async () => {
    try {
      let { data } = await predictionService.getPrediction(id);
      let data1 = await matchService.getMatch(id);

      console.log("prediction already", data1,data);
      let finalData = {...data1.data[0],userPrediction:data[0]}
      setMatch(finalData);
    }
    catch (err) {
      console.log(err);
      toast.error("Matche can't be seen!!!");
      redirectToLogin(navigate);
    }
  }
  const getMatch = async () => {
    try {
      let { data } = await matchService.getMatch(id);
      console.log("match adding,match", data,match);
      let finalData = {...match,...data[0]}
      setMatch(finalData);
    }
    catch (err) {
      toast.error("Matches can't be seen!!!");
      redirectToLogin(navigate);
    }
  }

  const handleSelection = (team, session, choice,selectedOdd) => {
    setSelections(prevSelections => ({
      ...prevSelections,
      [team]: {
        ...prevSelections[team],
        [session]: {choice,selectedOdd}
      }
    }));
  };

  const handleWinnerSelection = (team) => {
    const losingTeam = team === 'team1' ? 'team2' : 'team1';
    setSelections(prevSelections => ({
      ...prevSelections,
      [team]: { ...prevSelections[team], winner: true },
      [losingTeam]: { ...prevSelections[losingTeam], winner: false }
    }));
  };

  const handleSubmit = async () => {
    // Only submit if not already submitted
    if (!submitted) {
      await predictionService.doPrediction({...selections,match_id:id,"predictionType":"initial"});
      toast.success('Predictions submitted successfully!');
      setSubmitted(true); // Disable the button after submission
    }
  };

  if (!match?.predictions?.team1 || !selections?.team1) {
    console.log(selections,"selections");
    return <div>Loading...</div>;
  }
  else{
    console.log(match,"match");
  }

  const [teamOneName = "Team 1", teamTwoName = "Team 2"] = (match?.title?.split(" vs ") || []).map(t => t?.trim());
  debugger
  return (
    <div className="prediction-view">
      <div className="prediction-hero">
        <div className="prediction-meta">
          <div className="meta-title">{match.title}</div>
          <div className="meta-sub">
            <span className="pill">{match.matchStatus || 'Upcoming'}</span>
            <span className="pill ghost">{match.published_at}</span>
            {match?.venue && <span className="pill ghost">{match.venue}</span>}
          </div>
          {match?.tags?.length ? (
            <div className="tag-row">
              {match.tags[0].split(',').map(tag => (
                <span key={tag} className="tag-pill">#{tag.trim()}</span>
              ))}
            </div>
          ) : null}
        </div>
        <div className="hero-flags">
          <div className="flag-block">
            <img src={match?.flagImages?.team1} alt={`${teamOneName} Flag`} />
            <div className="team-name">{teamOneName}</div>
          </div>
          <div className="vs-badge">VS</div>
          <div className="flag-block">
            <img src={match?.flagImages?.team2} alt={`${teamTwoName} Flag`} />
            <div className="team-name">{teamTwoName}</div>
          </div>
        </div>
        {match?.content && (
          <p className="meta-description">
            {match?.content?.length > 180 ? `${match?.content?.slice(0, 180)}...` : match?.content}
          </p>
        )}
      </div>

      <div className="card-container">
        <Card className="match-card">
          <div className="session-options-container">
            {/* Team 1 */}
            <div className="team-options">
              <h3 className="team-title">{teamOneName}</h3>
              {match?.sessions?.map((session) => (
                <div className="session" key={session}>
                  <p className="session-label">{session} Over Session Odds</p>
                  <div className="odds-row">
                    <Button
                      variant={selections?.team1?.[session]?.choice === 'no' ? 'danger' : 'outline-danger'}
                      className={`session-button ${selections?.team1?.[session]?.choice === 'no' ? 'no' : selections?.team1?.[session]?.choice === 'yes' ? 'yes' : 'default'}`}
                      onClick={() => handleSelection('team1', session, 'no',match?.predictions?.team1?.[session]?.[0])}
                      disabled={submitted} // Disable if submitted
                    >
                      {match?.predictions?.team1?.[session]?.[0]}
                    </Button>
                    <Button
                      variant={selections?.team1?.[session]?.choice === 'yes' ? 'success' : 'outline-success'}
                      className={`session-button ${selections?.team1?.[session]?.choice === 'yes' ? 'yes' : selections?.team1?.[session]?.choice === 'no' ? 'no' : 'default'}`}
                      onClick={() => handleSelection('team1', session, 'yes',match?.predictions?.team1?.[session]?.[1])}
                      disabled={submitted} // Disable if submitted
                    >
                      {match?.predictions?.team1?.[session]?.[1]}
                    </Button>
                  </div>
                  <div className="odds-hint">
                    {match?.predictions?.team1?.[session]?.[0]} - {match?.predictions?.team1?.[session]?.[1]}
                  </div>
                </div>
              ))}
              <div className={"winner-button-container"}>
                <Button
                  variant="success"
                  onClick={() => handleWinnerSelection('team1')}
                  className={selections?.team1?.winner ? "Winner" : "Loser"}
                  disabled={submitted} // Disable if submitted
                >
                  {selections?.team1?.winner ? "Winner" : "Loser"}
                </Button>
              </div>
            </div>

            {/* VS Separator */}
            <div className="vs-separator">
              <span>VS</span>
            </div>

            {/* Team 2 */}
            <div className="team-options">
              <h3 className="team-title">{teamTwoName}</h3>

              {match?.sessions?.map((session) => (
                <div className="session" key={session}>
                  <p className="session-label">{session} Over Session Odds</p>
                  <div className="odds-row">
                    <Button
                      variant={selections?.team2?.[session]?.choice === 'no' ? 'danger' : 'outline-danger'}
                      className={`session-button ${selections?.team2?.[session]?.choice === 'no' ? 'no' : selections?.team2?.[session]?.choice === 'yes' ? 'yes' : 'default'}`}
                      onClick={() => handleSelection('team2', session, 'no',match?.predictions?.team1?.[session]?.[0])}
                      disabled={submitted} // Disable if submitted
                    >
                      {match?.predictions?.team2?.[session]?.[0]}
                    </Button>
                    <Button
                      variant={selections?.team2?.[session]?.choice === 'yes' ? 'success' : 'outline-success'}
                      className={`session-button ${selections?.team2?.[session]?.choice === 'yes' ? 'yes' : selections?.team2?.[session]?.choice === 'no' ? 'no' : 'default'}`}
                      onClick={() => handleSelection('team2', session, 'yes',match?.predictions?.team1?.[session]?.[1])}
                      disabled={submitted} // Disable if submitted
                    >
                      {match?.predictions?.team2?.[session]?.[1]}
                    </Button>
                  </div>
                  <div className="odds-hint">
                    {match?.predictions?.team2?.[session]?.[0]} - {match?.predictions?.team2?.[session]?.[1]}
                  </div>
                </div>
              ))}
              <div className={"winner-button-container"}>
                <Button
                  variant="success"
                  onClick={() => handleWinnerSelection('team2')}
                  className={selections?.team2.winner ? "Winner" : "Loser"}
                  disabled={submitted} // Disable if submitted
                >
                  {selections?.team2.winner ? "Winner" : "Loser"}
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
